import { takeLatest } from 'redux-saga/effects'

import { downloadQrCodesSaga } from './sagas/download-qr-code.saga'
import { actionTypes } from './actions'

export function* qrCodesWatchSaga() {
  yield takeLatest(actionTypes.DOWNLOAD_QR_CODE, downloadQrCodesSaga)
}
